import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { AuthGuard } from 'app/auth/auth.guard';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import { PerfilUsuarioComponent } from './perfil-usuario.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';

const rutas = [
  {
    path     : 'my_profile',
    component: PerfilUsuarioComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [PerfilUsuarioComponent, ConfiguracionComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatInputModule,
    MatSnackBarModule
  ]
})
export class PerfilUsuarioModule { }
